// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { PublicOrgInfo } from "generated/mos/user";
import { Codec, DecodeContext, RemoteObject, Timestamp, WebRPCError, ensureScalar, ensureScalarOptional } from "generated/webrpc";

export namespace GetConfigRequest {
  export const refName = "mos.admin.config.GetConfigRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly orgSlug: string,
  }
  export const defaults: Entity = {
    type: refName,
    orgSlug: "",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.admin.config.GetConfigRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["orgSlug"] = ensureScalar(ctx, v["orgSlug"], "string");
      return out as any as Entity;
    }
  }();
}

export namespace GetConfigResponse {
  export const refName = "mos.admin.config.GetConfigResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly revisionHash: string,
    readonly revisionDate: Timestamp | undefined,
    readonly publicOrgInfo: PublicOrgInfo.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    revisionHash: "",
    revisionDate: undefined,
    publicOrgInfo: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["revisionHash"] = v.revisionHash;
      obj["revisionDate"] = v.revisionDate ? v.revisionDate.value : "";
      obj["publicOrgInfo"] = PublicOrgInfo.codec.encode(v.publicOrgInfo);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.admin.config.GetConfigResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["revisionHash"] = ensureScalar(ctx, v["revisionHash"], "string");
      {
        const tsv = ensureScalarOptional(ctx, v["revisionDate"], "string");
        out["revisionDate"] = tsv ? {type: "google.protobuf.Timestamp", value: tsv} : undefined;
      }
      out["publicOrgInfo"] = ctx.decode(PublicOrgInfo.codec, v["publicOrgInfo"], "publicOrgInfo");
      return out as any as Entity;
    }
  }();
}

